import React from 'react';
import "./button.scss";

export default function Button(props) {
  return (
    <button className={`custom-button ${props.primaryButton === true ? 'primary-btn' : 'secondary-btn'}`} onClick={props.buttonClickHandler} data-id={props.id}>{props.children}</button>
  )
}
